<input
  class="form-control"
  type="text"
  mask="+0*"
  placeholder="+5511999999999"
  [dropSpecialCharacters]="false"
  [formControl]="formControl"
  [formlyAttributes]="field"
/>
